import { Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'common/hooks/useNavigate';
import { GetProfileInfo } from 'services/profile/ProfileService';
import RegisterFamiliplusCard from '../../../components/RegisterFamiliplusCard';
import useAuth0 from 'common/hooks/useAuth0';
import { Helmet } from 'react-helmet';
import useApi, { Status } from 'common/hooks/useApi';
import LoadingIndicator from 'components/common/LoadingIndicator';
import { SyncAccount } from 'components/common/syncAccount';

const FamiliplusCardPage = (): JSX.Element => {
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const { user, getAccessTokenSilently } = useAuth0();
  const [authProvider, setAuthProvider] = useState({ sessionId: '', token: '' });
  const [fetchProfile, profileInfo, fetchingProfileStatus] = useApi(GetProfileInfo);
  const { t, i18n } = useTranslation('component');

  const isDataLoading = fetchingProfileStatus === Status.Pending;
  const hasFetchDataFailed = fetchingProfileStatus === Status.Rejected;
  const isDataResolved = fetchingProfileStatus === Status.Resolved;

  useEffect(() => {
    const fetchData = async () => {
      setAuthProvider({ sessionId: user?.session_id, token: await getAccessTokenSilently() });
    };
    fetchData();
  }, [getAccessTokenSilently, user?.session_id]);

  useEffect(() => {
    if (authProvider && authProvider.sessionId.length > 0 && authProvider.token.length > 0) {
      fetchProfile(authProvider);
    }
  }, [authProvider, fetchProfile]);

  useEffect(() => {
    if (currentStep) {
      SyncAccount();
      navigate(`/${i18n.resolvedLanguage}/${i18n.resolvedLanguage == 'fr' ? 'Compte' : 'Account'}/Familiplus`);
    }
  }, [currentStep, navigate, i18n]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('MetaTag.FamiliplusCardTitle')}</title>
        <meta name="description" content={t('MetaTag.FamiliplusCardDescription').toString()} />
      </Helmet>

      {isDataLoading && <LoadingIndicator />}

      {hasFetchDataFailed && (
        <Alert severity="error" data-cy="ErrorAlert" sx={{ mb: '16px' }}>
          {t('Errors.GenericError')}
        </Alert>
      )}

      {isDataResolved && profileInfo && (
        <RegisterFamiliplusCard
          stepHandler={setCurrentStep}
          currentStep={currentStep}
          profileAuth={authProvider}
          profile={profileInfo}
          //méthode inutilisé pour cette page
          profileHandler={() => {}} //eslint-disable-line @typescript-eslint/no-empty-function
          customTitle="AltTitle"
          hasPrevious={false}
          hasSkip={false}
          showAdvantages={false}
          customSubmitText={t('Buttons.Confirm').toString()}
          isCreatingAccount={false}
        />
      )}
    </>
  );
};

export default FamiliplusCardPage;
